import styled from 'styled-components';
import { motion } from 'framer-motion';

const StyledToogle = styled.div`
  display: flex;
`;

const StyledToogleInput = styled.div`
  border-radius: 100px;
  width: 35px;
  height: 18px;
  display: flex;
  align-items: center;
  margin-right: 11px;
  cursor: pointer;
  background-color: ${({ checked, theme }) => (checked ? theme.colors.mainColor : theme.colors.gray300)};
  justify-content: ${({ checked }) => (checked ? 'flex-end' : 'flex-start')};
`;

const StyledToogleInputValue = styled(motion.div)`
  margin-left: 3px;
  margin-right: 3px;
  width: 14px;
  border-radius: 100px;
  height: 14px;
  ${({ checked, theme }) => (checked
    ? `background: ${theme.colors.mainColorBackground}`
    : `background: ${theme.colors.gray400}`)}
`;

const StyledToogleLabel = styled.label`
  ${({ theme }) => theme.typograph.paragraphRegular}
  color: ${({ theme }) => theme.colors.textColorSecondary}
`;

export {
  StyledToogle,
  StyledToogleInput,
  StyledToogleLabel,
  StyledToogleInputValue,
};
